export const DEFAULT_CATEGORY = "Favorites";
